import { render, staticRenderFns } from "./SwitchAdminForPremiumMember.vue?vue&type=template&id=6eeff780&scoped=true&"
import script from "./SwitchAdminForPremiumMember.vue?vue&type=script&lang=js&"
export * from "./SwitchAdminForPremiumMember.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAdminForPremiumMember.vue?vue&type=style&index=0&id=6eeff780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeff780",
  null
  
)

export default component.exports